// utils/documentos.ts
import { safeFetch } from '@/api/safeFetch';
import { construirFormData, base64ToPdfBlob } from './pdfHelpers';

/**
 * Subir un contrato PDF al backend
 */
export async function subirContrato(
  pdfBase64: string,
  formData1: any,
  payment_intent_id: string,
  filename?: string,
) {

const blob = base64ToPdfBlob(pdfBase64);
const datos = construirFormData('contrato', blob, formData1, payment_intent_id, undefined, filename);

  const res = await safeFetch(`/api/contrato`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    },
    body: datos
  });

  if (!res.ok) throw new Error(`Error subiendo contrato: ${res.status}`);

  const json = await res.json();
  if (json.numeroContrato) sessionStorage.setItem('numeroContrato', json.numeroContrato);

  return json;
}

export async function subirFactura(
  pdfBase64: string,
  formData1: any,
  payment_intent_id: string,
  total: number,
  filename?: string,
) {
  if (total == null) throw new Error("Total no puede ser undefined");

  const blob = base64ToPdfBlob(pdfBase64); // 🔥 CORRECTO
  const datos = construirFormData('factura', blob, formData1, payment_intent_id, total, filename);

  const res = await safeFetch(`/api/factura`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    },
    body: datos
  });

  if (!res.ok) throw new Error(`Error subiendo factura: ${res.status}`);

  const json = await res.json();
  if (json.numeroFactura) sessionStorage.setItem('numeroFactura', json.numeroFactura);

  return json;
}



// src/api/documentos.ts

export const reservarNumero = async (
  tipo: "contrato" | "factura",
  profesionalId?: number,
  perfilId?: number,
  usuarioId?: number
): Promise<string | undefined> => {
  if (!profesionalId) return undefined;
  if (tipo === "contrato" && !perfilId) return undefined;

  try {
    const res = await safeFetch(`/api/reservar-numero`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        tipo,
        profesional_id: profesionalId,
        perfil_profesional_id: tipo === "contrato" ? perfilId : undefined,
        usuario_id: usuarioId,
      }),
    });

    if (!res.ok) return undefined;
    const json = await res.json();
    return json.numero as string | undefined;
  } catch (err) {
    console.warn(`❕ Error reservando número de ${tipo}:`, err);
    return undefined;
  }
};
